import React, { useEffect } from "react";
import { SHOP_ID_BAR_TAMARIBA_TAKEPEACE } from "../../../constants";

function RedirectBarTamaribaTakepeace() {
  useEffect(() => {
    window.location.replace(`/mogugori/shopDetail/${SHOP_ID_BAR_TAMARIBA_TAKEPEACE}`);
  }, []);

  return null;
}

export default RedirectBarTamaribaTakepeace;
